import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ChevronsUpIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17.1451 1.47104L30.5187 14.6494C31.545 15.6501 30.8212 17.3745 29.3736 17.3745H23.5834C23.1513 17.3745 22.7408 17.2042 22.4384 16.9061L16 10.5618L9.56164 16.9061C9.25917 17.2042 8.84867 17.3745 8.41657 17.3745H2.62636C1.17881 17.3745 0.455039 15.6501 1.48129 14.6494L14.8549 1.47104C15.4923 0.842988 16.5185 0.842988 17.1451 1.47104ZM14.8549 15.0965L1.48129 28.2749C0.465841 29.2862 1.17881 31 2.62636 31H8.41657C8.84867 31 9.25917 30.8297 9.56164 30.5316L16 24.1873L22.4384 30.5316C22.7408 30.8297 23.1513 31 23.5834 31H29.3736C30.8212 31 31.545 29.2755 30.5187 28.2749L17.1451 15.0965C16.5185 14.4685 15.4923 14.4685 14.8549 15.0965Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
